import { IModelActor, IModelSpotUpdate } from './oxygenModel'
import { l } from '../lib/imports'
import { machines } from '../machines/machines-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { scene } from '../main/scene-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { machinesOxygenGenerator } from '../machines/machinesOxygenGenerator-sidecar'
import { machinesOxygenGeneratorEm } from '../machines/machinesOxygenGeneratorEm-sidecar'

export function collectModelActors() {
  let actors: IModelActor[] = []

  l.forEach(machines.getAll(), (c) => {
    if (c.data.type === 'o2gen-em') {
      if (machinesOxygenGeneratorEm.isRunning(c)) {
        actors.push({
          i: c.i,
          j: c.j,
          type: 'o2gen',
          setPoint: 70, // TODO: setpoints on machine, check if on
        })
      }
    }

    if (c.data.type === 'o2gen') {
      if (machinesOxygenGenerator.isRunning(c)) {
        actors.push({
          i: c.i,
          j: c.j,
          type: 'o2gen',
          setPoint: 70,
        })
      }
    }
    if (c.data.type === 'co2scrubber') {
      actors.push({
        i: c.i,
        j: c.j,
        type: 'co2scrubber',
        setPoint: 30,
      })
    }
  })

  l.forEach(monsters.getAll(), (c) => {
    actors.push({
      i: c.i,
      j: c.j,
      type: 'human',
    })
  })

  return actors
}

export function collectSyncs(): IModelSpotUpdate[] {
  let syncs: IModelSpotUpdate[] = []

  let ctx = scene.getContext()

  tileMapShip.forEachTile(ctx.mapShip, (c) => {
    syncs.push({
      isSpace: c.dataFloor === null,
      isHull: c.dataFloor != null && c.dataFloor.isHull === true,
    })
  })

  return syncs
}
